import { actions } from '../constants/virtualClass';
import * as actionTypes from '../../models/action/virtualClass';
import { IAction } from '../../models/action/core';

// #region Join VirtualClass Action
export function joinVirtualClassGetAction(ActivityId: string | null, VirtualClassRemoteId: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void) {
    return {
        ActivityId,
        VirtualClassRemoteId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.JOIN_VIRTUALCLASS_ACTIVITY,
        callback
    };
}

export function joinVirtualClassSetAction(data: string | null, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        virtualClassPerculusUrl: data,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.JOIN_VIRTUALCLASS_SET_ACTIVITY
    };
}
// #endregion Join VirtualClass Action

// #region Add VirtualClass Action
export function addVirtualClassGetAction(data: actionTypes.IVirtualClassData, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IGetAddVirtualClass {
    return {
        VirtualClassData: data,
        timestamp: Date.now(),
        type: actions.ADD_VIRTUALCLASS_ACTIVITY,
        callback
    };
}

// Add VirtualClass Update Get Action
export function updateVirtualClassGetAction(
    dataParams: actionTypes.IVirtualClassParams,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IUpdateVirtualClassGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_VIRTUALCLASS_UPDATE_ACTIVITY
    };
}

export function setVirtualClassDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_VIRTUALCLASS_DATA_DEFAULT
    };
}

export function addVirtualClassSetAction(
    VirtualClassData: actionTypes.IVirtualClassData[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.ISetAddVirtualClass {
    return {
        VirtualClassData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_VIRTUALCLASS_SET_ACTIVITY
    };
}
// #endregion Add VirtualClass Action

// #region Add VirtualClass Action
export function deleteVirtualClassGetAction(data: actionTypes.DeleteData): actionTypes.IGetDeleteVirtualClass {
    return {
        VirtualClassData: data,
        timestamp: Date.now(),
        type: actions.DELETE_VIRTUALCLASS_ACTIVITY
    };
}

export function deleteVirtualClassSetAction(deleteVirtualClassStatus: boolean): actionTypes.ISetDeleteVirtualClass {
    return {
        deleteVirtualClassStatus,
        timestamp: Date.now(),
        type: actions.DELETE_VIRTUALCLASS_SET_ACTIVITY
    };
}

export function getMyVirtualClassGetAction(
    Filters: actionTypes.IFilters,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IGetMyVirtualClass {
    return {
        Filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_MY
    };
}

export function getMyVirtualClassSetAction(
    MyVirtualClass: actionTypes.IMyVirtualClass[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    isLastActivity?: boolean
): actionTypes.ISetMyVirtualClass {
    return {
        MyVirtualClass,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MY,
        isLastActivity
    };
}

export function reCalculateVirtualClass(ActivityId: string | null, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void) {
    return {
        ActivityId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.RECALCULATE_VIRTUALCLASS_ACTIVITY,
        callback
    };
}

// #endregion Add VirtualClass Action
